export const parseLimit = (limit?: number | string): number | undefined => {
  if (limit === undefined || limit === null) {
    return
  }

  if (typeof limit === 'number') {
    return Number.isNaN(limit) ? undefined : limit
  }

  const parsed = Number.parseInt(limit, 10)
  return Number.isNaN(parsed) ? undefined : parsed
}
